import template from './checkout-review.html';

export const link = ({ url, text }) => `
    <a href="${url}" class="checkout-selector__btn">
        ${text}
    </a>
`;

export default template;
